import React from "react";
import { useSavings } from "../../context/SavingsContext";
import { calculateTotalSavings } from "../../utils/calculations";

const SavingsCounter: React.FC = () => {
  const { data } = useSavings();
  const totalSavings = calculateTotalSavings(data.entries);

  // Function to format currency with commas
  const formatCurrency = (amount: number): string => {
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="bg-gray-900 p-8 rounded-lg text-center mb-8">
      <h2 className="text-2xl mb-2">Estimated Savings</h2>
      <div className="text-6xl font-bold text-yellow-300 mb-4">
        {formatCurrency(totalSavings)}
      </div>
      <p className="text-gray-400">
        Combination of one-time savings and projected annual recurring savings
      </p>
    </div>
  );
};

export default SavingsCounter;
